export default "__VITE_ASSET__CvG0hqQm__"